import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AggregatorInvestmentBox } from 'components/aggregator/aggregatorBoxes/aggregatorInvestmentBox/aggregatorInvestmentBox';
import { AggregatorGenericView } from './aggregatorGenericView/aggregatorGenericView';

import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

import { INVESTMENTS } from 'constants/aggregator/products';

class AggregatorInvestmentsViewClass extends React.PureComponent {
  getProductComponent(product, isTinkAggregator) {
    const userBankId = product.get('userBankId');

    return (
      product && (
        <AggregatorInvestmentBox
          key={userBankId}
          investments={product}
          isTinkAggregator={isTinkAggregator}
        />
      )
    );
  }

  render() {
    const { immFlagBasedFeatures } = this.props;

    const isTinkAggregator = immFlagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    return (
      <AggregatorGenericView
        hasDetails={false}
        productType={INVESTMENTS}
        getProductComponent={this.getProductComponent}
        isTinkAggregator={isTinkAggregator}
      />
    );
  }
}

AggregatorInvestmentsViewClass.propTypes = {
  immFlagBasedFeatures: PropTypes.object,
};

AggregatorInvestmentsViewClass.defaultProps = {
  immFlagBasedFeatures: {},
};

const AggregatorInvestmentsView = connect(state => {
  return {
    immFlagBasedFeatures: state.flagBasedFeatures,
  };
})(AggregatorInvestmentsViewClass);

export { AggregatorInvestmentsView };
